import './Footer.css';
function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          © 2021 S.Q.T — Serviços de Teste de Software, Automação e Consultoria em Qualidade.
        </div>
      </footer>
      <a href="#inicio" className="backToTop" aria-label="Voltar ao início">↑</a>
    </>
  );
}

export default Footer;
